<nav class="navbar navbar-expand-md navbar-dark bg-dark">
  <a class="navbar-brand" href="#">
    <img src="../../../assets/cotagro1.png" width="70" height="30"
      class="d-inline-block align-top navbarImageBackground" alt="Campos">
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
    aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <button class="btn btn-sm btn-outline-success" type="button" title="Exportar"
    (click)="exportFieldsClassificationXlsx()">
    <i class="fa fa-file"></i> Exportar</button>
  <button *ngIf="administratorAccess" class="btn btn-sm btn-outline-success" type="button" title="Exportar"
    (click)="exportSalesDTAXlsx()">
    <i class="fa fa-file"></i> Ventas DTA</button>
  <button class="btn btn-sm btn-outline-info" type="button" title="Descargar KMZ de todos los polígonos"
    (click)="downloadAllPolygonsKMZ()">
    <i class="fa fa-globe"></i> KMZ Campos</button>
  <div class="collapse navbar-collapse" id="navbarCollapse">
    <ul class="navbar-nav mr-auto">
      <li *ngIf="administratorAccess" class="nav-item">
        <a class="nav-link" routerLink="/home">Campos</a>
      </li>
      <li *ngIf="administratorAccess" class="nav-item">
        <a class="nav-link" routerLink="/dashboard">Dashboard</a>
      </li>
      <li *ngIf="administratorAccess" class="nav-item">
        <a class="nav-link" routerLink="/reassign">Reasignar Operador Comercial</a>
      </li>
    </ul>
    <div class="form-inline mt-2 mt-md-0">
      <i class="fa fa-user-o mr-4 text-light"> {{activeProfileName}}</i>
      <button class="btn btn-sm btn-outline-danger my-2 my-sm-0" type="button" title="Cerrar sesión"
        (click)="logout()"><i class="fa fa-sign-out"></i></button>
    </div>
  </div>
</nav>